import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
	name: "filterByProp",
})
export class FilterByPropPipe implements PipeTransform {
	transform(arr: any[], field: string, search: string): any[] {
		return arr.filter((it) => it[field].includes(search))
	}
}
